module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-bet@1x.png?1.0.17";